import { render, staticRenderFns } from "./vuetifyRow.vue?vue&type=template&id=7bb484b8&scoped=true&"
import script from "./vuetifyRow.vue?vue&type=script&lang=js&"
export * from "./vuetifyRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb484b8",
  null
  
)

export default component.exports